import { useEffect, useState } from "react";

import { Container, Grid } from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";

import DialogCreateEdit from "./components/dialog-create-edit";
import DialogPreviewDocument from "./components/dialog-preview-document";
import TableManuaisEProcedimentos from "./components/table-manuais-procedimentos";
import HeaderClientes from "components/_refactor/headers/clients";
import LoadingData from "components/Loading/LoadingData";
import FilterCard from "components/_refactor/filter-card";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

const loadingItems = [
  { IdMenu: "0" },
  { IdMenu: "1" },
  { IdMenu: "2" },
  { IdMenu: "3" },
  { IdMenu: "4" },
  { IdMenu: "5" },
  { IdMenu: "6" },
  { IdMenu: "7" },
  { IdMenu: "8" },
  { IdMenu: "9" },
];

const options = [
  { value: "MANUAL", name: "Manual", id: 1 },
  {
    value: "PROCEDIMENTO",
    name: "Procedimento",
    id: 2,
  },
  {
    value: "OUTROS",
    name: "Outros",
    id: 3,
  },
];

export default function GestaoConteudo() {
  const snackbar = useSnackbar();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const [type, setType] = useState(options[0]);
  const [documentsList, setDocumentsList] = useState(loadingItems);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searching, setSearching] = useState(true);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);
  const [cancelLoading, setCancelLoading] = useState(false);

  const toggleFormDialog = (formType) => {
    if (formType) {
      setOpenFormDialog(formType);
    }
  };

  const updateList = async (openFormDialog, updatedMenu) => {
    // if (openFormDialog === "delete") {
    //   const filteredMenu = menus.filter(
    //     (menu) => menu.IdMenu !== updatedMenu.IdMenu
    //   );
    //   setMenus(filteredMenu);
    // } else {
    //   const newMenuList = menus.map((menu) => {
    //     if (menu.IdMenu === updatedMenu.IdMenu) return updatedMenu;
    //     else return menu;
    //   });
    //   setMenus(newMenuList);
    // }
  };

  const handleSearch = async ({ page, sizePerPage }) => {
    setSearching(true);
    setCancelLoading(false);
    setCurrentPage(page);
    setCurrentSizePerPage(sizePerPage);

    try {
      const res = await Api.get(
        "document-list",
        "conteudo",
        `?page=${page}` + `&pageSize=${sizePerPage}` + `&tipo=${type.value}`,
        true
      );
      setDocumentsList(res?.Result?.Documentos || []);
      setTotalRegisters(res?.Result?.TotalRegistro);
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "149",
        screen: "Manuais e Procedimentos",
        problem: `Erro na chamada do endpoint document-list - ${error}`,
      });
    } finally {
      setSearching(false);
    }
  };

  const handleRefresh = async () => {
    setSearching(true);

    return handleSearch({
      page: currentPage,
      sizePerPage: currentSizePerPage,
    });
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setDocumentsList([]);
  };

  const handleTypeChange = (value) => {
    if (value !== "all") {
      setType(value);
    } else {
      setType("");
    }
  };

  const handleSearchClick = () => {
    handleSearch({
      page: currentPage,
      sizePerPage: currentSizePerPage,
    });
    setLocalStorageActions({
      nomeTela: "Manuais e Procedimentos",
      idMenu: "149",
      acao: "Clicou para Pesquisar",
    });
  };

  const handleClearFilters = () => {
    setType("");
    setDocumentsList([]);
  };

  const handleDialogClose = (document) => {
    setSelectedDocument(null);
    if (document?.IdDocumentoArea > 0) {
      if (openFormDialog === "create") {
        const newDocumentList = [...documentsList, { ...document }];
        setDocumentsList(newDocumentList);
      } else {
        updateList(openFormDialog, document);
      }
    }
    setOpenFormDialog(null);
  };

  const handlePreviewClose = () => {
    setOpenFormDialog(null);
  };

  useEffect(() => {
    handleSearch({
      page: currentPage,
      sizePerPage: currentSizePerPage,
    });
  }, []);

  return (
    <>
      <HeaderClientes section="Gestão de Manuais" subsection="Conteúdo" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearchClick}
          disabled={searching}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xs={12} md={4}>
            <AutoCompleteField
              label="Tipo"
              onChange={handleTypeChange}
              value={type}
              options={options}
              disabled={searching}
              optionLabelKey="name"
              optionIdKey="id"
            />
          </Grid>
        </FilterCard>

        <LoadingData
          searching={searching}
          onClick={handleStopSearching}
          label="Buscando dados..."
        />

        {!searching && documentsList && !cancelLoading && (
          <TableManuaisEProcedimentos
            dataTable={documentsList}
            page={currentPage}
            sizePerPage={currentSizePerPage}
            totalRegistros={totalRegisters}
            search={(_, { page, sizePerPage }) => {
              handleSearch({ page: page - 1, sizePerPage });
            }}
            toggleFormDialog={toggleFormDialog}
            setSelectedDocument={setSelectedDocument}
            searching={searching}
            selectedDocument={setSelectedDocument}
          />
        )}
      </Container>

      {Boolean(openFormDialog) && openFormDialog !== "view" && (
        <DialogCreateEdit
          open
          formType={openFormDialog}
          onClose={handleDialogClose}
          selectedRow={selectedDocument}
          typeForm={openFormDialog}
          refresh={handleRefresh}
        />
      )}

      {Boolean(openFormDialog) && openFormDialog === "view" && (
        <DialogPreviewDocument
          open
          selectedRow={selectedDocument}
          onClose={handlePreviewClose}
        />
      )}
    </>
  );
}
